import Vue from 'vue';
import ScrollTopArrow from '@/components/shared/ScrollTopArrow';
import VueCookie from 'vue-cookie';
// Shared components
import LinkTo from '../components/shared/_any/LinkTo'
import Vue2Touch from 'vue2-touch'

import InputText from "../components/shared/_any/InputText";
import InputFile from "../components/shared/_any/InputFile";
import InputFileMultiple from "../components/shared/_any/InputFileMultiple";
import InputTextarea from "../components/shared/_any/InputTextarea";
import VueAnimateNumber from 'vue-animate-number'
import Slider from '@/components/shared/sliders/Slider';
Vue.use(Vue2Touch);
Vue.use(VueAnimateNumber);
//vue-cookie
Vue.use(VueCookie);

Vue.component('LinkTo', LinkTo);

Vue.component('InputText', InputText);
Vue.component('InputFile', InputFile);
Vue.component('InputFileMultiple', InputFileMultiple);
Vue.component('InputTextarea', InputTextarea);
Vue.component('Slider', Slider);

//

 Vue.component('ScrollTopArrow', ScrollTopArrow);



// WEBPACK FOOTER //
// ./plugins/shared-components.js